module.exports = __webpack_public_path__ + "media/assets/staffs/ian-2037c35481dc9f0759672dffa57f52f7.png";